// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"d8e7fa34","287":"c0a2f3c7","290":"76291408","344":"b71deb09","550":"bbfeefab","608":"b8bfc3a6","841":"23f14816"}[chunkId] + ".chunk.js";
};